import React from 'react'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import Privacy from '../containers/Privacy'

const TermsPage = ({ isNew }) => {
  return (
    <>
      <Privacy isNew={isNew} />
    </>
  )
}

export const getServerSideProps = async ({ locale, query }) => ({
  props: {
    isNew: !('old' in query),
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
    ])),
  },
})

export default TermsPage
